import { Quota } from '../objects/quota';
import { Config } from '../objects/config';
import { ClientBranchCompany } from '../../margin/objects/company';

export const SET_CONFIG = 'HEADER_SET_CONFIG';
export const SET_GOOGLE = 'HEADER_SET_GOOGLE';
export const UPDATE_QUOTA = 'HEADER_UPDATE_QUOTA';
export const TOGGLE_IS_BI = 'HEADER_TOGGLE_IS_BI';
export const SET_AVAILABLE_CLIENT_BRANCHES = 'HEADER_SET_AVAILABLE_CLIENT_BRANCHES';

interface SetConfigAction {
    type: typeof SET_CONFIG,
    payload: Config
}

interface SetGoogleAction {
    type: typeof SET_GOOGLE,
    payload: any
}

interface UpdateQuotaAction {
    type: typeof UPDATE_QUOTA,
    payload: Quota
}

interface ToggleIsBiAction {
    type: typeof TOGGLE_IS_BI,
    payload: boolean
}

interface SetAvailableClientBranchesAction {
    type: typeof SET_AVAILABLE_CLIENT_BRANCHES,
    payload: ClientBranchCompany[]
}

export type HeaderActionTypes =
    SetConfigAction |
    SetGoogleAction |
    UpdateQuotaAction |
    ToggleIsBiAction |
    SetAvailableClientBranchesAction;